import { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import axios from "axios";
import { API, useAuth } from "@/App";
import { toast } from "sonner";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getToken } = useAuth();
  const headers = { Authorization: `Bearer ${getToken()}` };

  const fetchMessages = async () => {
    try {
      const res = await axios.get(`${API}/admin/messages`, { headers });
      setMessages(res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchMessages(); }, []);

  const markRead = async (id) => {
    try {
      await axios.put(`${API}/admin/messages/${id}`, {}, { headers });
      toast.success("Marked as read");
      fetchMessages();
    } catch (e) { toast.error("Failed"); }
  };

  return (
    <div className="space-y-4" data-testid="admin-messages">
      <h1 className="font-heading text-2xl font-bold text-gray-900">Contact Messages ({messages.length})</h1>

      {loading ? (
        <div className="space-y-3">{[...Array(3)].map((_, i) => <div key={i} className="h-20 bg-gray-200 animate-pulse rounded-lg" />)}</div>
      ) : messages.length === 0 ? (
        <Card className="border-gray-200"><CardContent className="p-8 text-center text-gray-400">No messages yet.</CardContent></Card>
      ) : (
        <div className="grid gap-3">
          {messages.map((m) => (
            <Card key={m.id} className={`border-gray-200 ${m.read ? "opacity-60" : ""}`} data-testid={`message-${m.id?.slice(0,8)}`}>
              <CardContent className="p-4">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className="font-semibold text-gray-800">{m.name}</span>
                      <span className="text-xs text-gray-400">{m.email}</span>
                      {!m.read && <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">New</span>}
                    </div>
                    <p className="font-medium text-sm text-gray-700 mb-1">{m.subject}</p>
                    <p className="text-sm text-gray-500">{m.message}</p>
                    <p className="text-xs text-gray-400 mt-2">{new Date(m.created_at).toLocaleString()}</p>
                  </div>
                  {!m.read && (
                    <Button variant="ghost" size="sm" onClick={() => markRead(m.id)} className="text-green-600 shrink-0">
                      <Check className="w-4 h-4" />
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
